import script from "./SelectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBox.vue?vue&type=script&setup=true&lang=js"

import "./SelectBox.vue?vue&type=style&index=0&id=decdacd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-decdacd6"]])

export default __exports__